/*jshint esversion: 8 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import Button from '@material-ui/core/Button';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

import { sha3_512 } from 'js-sha3';

import store from '../../components/stores/Store';

import { signin } from '../../db/PublicRequestHandler';

import { updateLocalStorageFields } from '../../utils/LocalStorageHandler';

import { modeDes, hostName } from '../../config/ips';
import TradeStatistics from '../../components/TradeStatistics';
import { getIfFuncAuthorized } from '../../utils/CheckSomething';


const styles = {
  root: {
    flex: "1 1 auto",
    alignItems: "center",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    marginTop: '50px',
  },
  rootWelcome: {
    '& .MuiTextField-root': {
      margin: '10px',
      width: '25ch',
    },
  },
  paper: {
    padding: '8px',
    textAlign: 'center',
  },
};
// Home
class HomeInner extends Component {
  constructor() {
    super();
    this.state = {
      account: modeDes === '本地' ? '13800000001' : '',
      password: modeDes === '本地' ? '' : '',
      showPassword: false,
      localText: '',
    };
    this.login = this.login.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleClickShowPassword = this.handleClickShowPassword.bind(this);
    this.handleMouseDownPassword = this.handleMouseDownPassword.bind(this);
  }

  async componentDidMount() {
    const href = window.location.href;
    if (href.includes('localhost')) {
      const d = new Date();
      this.setState({ localText: d.getMinutes() });
    }
  }
  componentWillUnmount() {
    this.setState({
      count: {
        submit: '',
        selling: '',
        sold: '',
      },
    });
  }

  async login() {
    console.log(`----- account:  ${this.state.account}`);
    // 密码加密
    const password = sha3_512(this.state.password);

    const rst = await signin(this.state.account, password);
    if (rst.code === 'error') {
      store.openMessageDialogOpen(rst.msg || '登陆失败');
      return true;
    } else if (rst.code === 'success') {
      console.log(`----- rst: `, rst);
      store.userSignin({
        token: rst.token,
        marketId: rst.marketId,
        uuid: rst.uuid,
        memname: rst.memname,
        rolename: rst.rolename,
        authSettings: rst.rolePrivilege,
        phone: rst.phone || '',
      });
      store.setMarketId(rst.marketId);
      updateLocalStorageFields({
        uuid: rst.uuid,
        token: rst.token,
        marketId: rst.marketId || '9999',
      });
      return true;
    }
    return;
  }

  handleInputChange(e, prop) {
    e.stopPropagation();
    this.setState({ [prop]: e.target.value });
  }

  handleClickShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  handleMouseDownPassword(event) {
    event.preventDefault();
  }

  render() {
    const { classes } = this.props;
    if (store.user.rolename === '新注册用户') {
      return (
        <div className={classes.rootWelcome}>
          <Typography variant="h5" gutterBottom>
            主页
          </Typography>
          <Typography variant="h6" gutterBottom>
            新注册用户，请联系电话 13812588838
          </Typography>
        </div>
      );
    }
    if (store.user.logined && getIfFuncAuthorized('交易管理-交易记录统计')) {
      return (
        <>
          <Typography variant="h5" gutterBottom>
            交易记录统计
          </Typography>
          <div className={classes.rootWelcome}>
            <TradeStatistics />
          </div>
        </>
      );
    };
    if (store.user.logined && !getIfFuncAuthorized('交易管理-交易记录统计')) {
      return (
        <>
          <Typography variant="h5" gutterBottom>
            欢迎使用
          </Typography>
        </>
      );
    };
    return (
      <div className={classes.root}>
        <div>
          <Typography variant="h4">
            {hostName || ''}房票系统
          </Typography>
          <TextField fullWidth label="账号" name="email" type="email"
            value={this.state.account} variant="outlined" style={{ marginTop: '5rem' }}
            onChange={e => this.handleInputChange(e, 'account')} />

          <FormControl fullWidth variant="outlined" style={{ marginTop: '2rem' }}>
            <InputLabel htmlFor="outlined-adornment-password">密码</InputLabel>
            <OutlinedInput
              id="outlined-adornment-password"
              type={this.state.showPassword ? 'text' : 'password'}
              value={this.state.password}
              onChange={e => this.handleInputChange(e, 'password')}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={this.handleClickShowPassword}
                    onMouseDown={this.handleMouseDownPassword}
                    edge="end"
                  >
                    {this.state.showPassword ? <Visibility /> : <VisibilityOff />}
                  </IconButton>
                </InputAdornment>
              }
              labelWidth={70}
            />
          </FormControl>
          <Button fullWidth size="large" variant="contained" style={{ marginTop: '3rem' }} onClick={this.login}>
            确定
          </Button>
        </div>
        {/* <MessageDialog /> */}
      </div>
    );
  }
}

const Home = observer(HomeInner);

Home.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Home);
